<nx-dialog [dialogData]="data">
  <form [formGroup]="createTimerForm" class="dialog-content">
    <mat-form-field class="name" appearance="outline">
      <input
        type="text"
        matInput="name"
        placeholder="Name"
        #name
        formControlName="name"
        [errorStateMatcher]="immediateMatcher"
        autocomplete="off"
        maxlength="100"
        >
      <mat-hint align="end">{{name.value.length}} / 100</mat-hint>
      @if (createTimerForm.controls.name.hasError('nameFormatError')) {
        <mat-error>
          Der Timer mit solchem Namen exsistiert schon
        </mat-error>
      }
    </mat-form-field>
    <div class="dateAndStartTime">
      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="Datum auswählen"
          #pickerInput
          (dateChange)="changeDateValue($event.value)"
          [max]="maxDate"
          formControlName="datepicker"
          [errorStateMatcher]="immediateMatcher"
          >
        @if (createTimerForm.controls.datepicker.invalid) {
          <mat-error></mat-error>
        }
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <input
          type="text"
          formControlName="time"
          matInput="time"
          placeholder="Startzeit"
          #time
          [errorStateMatcher]="immediateMatcher"
          autocomplete="off"
          maxlength="5"
          >
        @if (createTimerForm.controls.time.hasError('timeFormatError')) {
          <mat-error>Zeitformat: HH:MM</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="durationAndActivityType">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Zeitdauer"
          formControlName="duration"
          #duration
          (keydown.enter)="saveTimer()"
          [errorStateMatcher]="immediateMatcher"
          autocomplete="off"
          maxlength="6"
          >
        @if (dateNotToday) {
          <mat-hint align="start"><strong>Timer in der Vergangenheit muss Zeitdauer haben!</strong>
        </mat-hint>
      }
      @if (createTimerForm.controls.duration.hasError('dateInFuture')) {
        <mat-error>
          Endzeit des Timers darf nicht in der Zukunft liegen
        </mat-error>
      }
      @if (createTimerForm.controls.duration.hasError('durationFormatError')) {
        <mat-error>
          Zeitformat: 1h30m/1h 30m/1h/1m
        </mat-error>
      }
      @if (createTimerForm.controls.duration.hasError('dateInPastWithoutDuration')) {
        <mat-error>
          Der Timer darf nicht in der Vergangenheit ohne Zeitdauer erstellt werden!
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-select
        placeholder="Typ" [disableOptionCentering]="true"
        (selectionChange)="getTypeValue($event)"
        formControlName="activityType"
        >
        @for (type of timerService.activityTypes; track type) {
          <mat-option [value]="type">
            {{type}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>

<button [disabled]="createTimerForm.invalid" mat-raised-button color="primary" (click)="saveTimer()"
  class="dialog-actions">Speichern
</button>
<button mat-raised-button color="warn" class="dialog-actions" mat-dialog-close="true">Abbrechen
</button>
</nx-dialog>

